import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Shanchu = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M34 9V7.015C34 5.91 33.12 5 32.015 5h-16.03C14.88 5 14 5.91 14 7.015V9H7.03C5.925 9 5 9.91 5 11.015 5 12.09 5.907 13 7.012 13H8.5v27a3 3 0 0 0 3 3h25a3 3 0 0 0 3-3V13h1.488C42.093 13 43 12.153 43 11.048v-.033C43 9.91 42.075 9 40.97 9H34ZM12.5 39V13h23v26h-23ZM18 19.996v11.008C18 32.11 18.91 33 20.015 33A2.003 2.003 0 0 0 22 31.004V19.996C22 18.89 21.09 18 19.985 18A2.003 2.003 0 0 0 18 19.996m8 0v11.008C26 32.11 26.91 33 28.015 33A2.003 2.003 0 0 0 30 31.004V19.996C30 18.89 29.09 18 27.985 18A2.003 2.003 0 0 0 26 19.996"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
